import { data } from 'jquery';
// import { Subscription, map } from 'rxjs';
// import { Component, effect, inject, signal, EventEmitter, Input, Output, type OnInit, ElementRef, ViewChild, TemplateRef, HostListener, computed } from "@angular/core";
import { Subject, Subscription, debounceTime, distinctUntilChanged, map } from 'rxjs';
import { Component, effect, inject, signal, EventEmitter, Input, Output, type OnInit, ElementRef, ViewChild, TemplateRef, HostListener, computed } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { SharedModule } from "../../shared/shared.moudle";
import { ChatStateService, TypingUser } from "../../../services/chat-state.service";
import { WebsocketService } from "../../../services/websocket.service";
import { ObjectId } from "bson";
import { DELEGATE_ID, SUCCESS, USER_ID } from '../../../data-models/user-data';
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { StorageService } from '../../../services/storage.service';
import { ChatMessage } from '../../../data-models/chat.modals';
import { environment } from '../../../../environments/environments';
import { UploadService } from '../../../services/upload.service';
import { ToastrService } from 'ngx-toastr';
import { MembersService } from '../members.service';
import { GroupsService } from '../../groups/groups.service';
import { FilePreviewComponent } from '../../shared/file-preview/file-preview.component';
import { InviewportDirective } from './inviewport.directive';
import { throttle } from 'lodash';
import { LoaderService } from '../../../services/loader.service';
import { Actions, Subjects } from '../../../services/authentication.service';
import { NoAccessComponent } from "../../no-access/no-access.component";
import { PureAbility } from '@casl/ability';

interface MessageOptions{
  ping: string,
  send_message: string,
  edit_message: string,
  delete_message: string,
  ack: string,
}

export const message_options: MessageOptions = {
  ping: 'ping',
  send_message: 'send_message',
  edit_message: 'edit_message',
  ack: 'ack',
  delete_message: 'delete_message'
};


interface Message {
  id: string
  senderId: string
  senderName: string
  senderAvatar: string
  content: string
  timestamp: Date
  status: "sent" | "delivered" | "read"
  type: any | "text" | "image" | "video" | "document"
  seq?: number
  media?: Media[]
}

interface Media {
  url: string
  type: string
  mime_type: string
  size: number
  name: string
  thumb_url: string
}

interface Participants {
  id: string
  name: string
  email: string
  avatar: string
  created_at: string
  basic_information: any
  profile_type?: any
  is_online?: boolean
}

interface Conversation {
  id: string
  group_id?: string
  name: string
  avatar: string
  lastMessage: string
  last_message?: any
  timestamp: Date
  unreadCount: number
  status: "new" | "in-progress" | "resolved"
  type: "parent-query" | "1-on-1" | "group" | "direct"
  default_type: any
  participants: string[]
}

interface MediaItem {
  id: string
  name: string
  type: "image" | "video" | "document" | "audio"
  size: string
  url: string
  timestamp: Date
  icon: string
}

interface LinkItem {
  id: string
  url: string
  title: string
  timestamp: Date
}

interface QueryItem {
  id: string
  question: string
  status: "in-progress" | "resolved"
  timestamp: Date
}

interface Contact {
  id: string
  name: string
  avatar: string
  role: string
  status: "online" | "offline"
  lastSeen?: string
  selected?: boolean
  groups?: string[]
}

interface Group {
  id: string
  name: string
  avatar: string
  memberCount: number
  lastActivity?: string
  selected?: boolean
  description?: string
}

const storage_user = environment.storage_user
const container_user = environment.container_user

@Component({
  selector: 'app-chat-bot-messenger',
  standalone: true,
  imports: [CommonModule, SharedModule, FilePreviewComponent, InviewportDirective, NoAccessComponent],
  templateUrl: './chat-bot-messenger.component.html',
  styleUrl: './chat-bot-messenger.component.scss'
})
export class ChatBotMessengerComponent {
  isMobile = false;
  @ViewChild('chatContainer') private chatContainer!: ElementRef;
  ws = inject(WebsocketService);
  state = inject(ChatStateService);
  connectionLabel = computed(() =>
    this.ws.connected() ? 'Connected' : 'Disconnected'
  );
  @Output() closePopup = new EventEmitter<void>()
  @Output() startChat = new EventEmitter<Contact[]>()
  @Output() createGroup = new EventEmitter<Contact[]>()
  id: any = ''
  delegate: any = ''
  searchTerm = ""
  searchTermAdd = ""

  modalReference: any;
  activeUnreadTab: "all" | "unread" = "all";

  @ViewChild("chatModal") chatModal!: TemplateRef<any>

  @Output() onChatCreated = new EventEmitter<any>()
  @Output() onClosed = new EventEmitter<void>()

  // Modal state
  currentModal: NgbModalRef | null = null
  currentStep: "selection" | "setup" = "selection"
  activeTabpop: "contacts" | "groups" = "contacts"
  addMemeberTab: "member" | "coach" | "admin" | "parent" = "member"
  selectedGroupFilter = "all"
  selectedGroupFiltername = "All"

  defaultsChats:any = [ "all" , "coaches" , "players&parents" , "admins"]

  // Group setup state
  groupName = ""
  groupPhoto: string | null = null
  selectedParticipants: Contact[] = []

  contacts: Contact[] = [
    {
      id: "1",
      name: "Sarah Wilson",
      avatar: "/images/samples/1280x768/2.jpg",
      role: "Parent",
      status: "online",
      selected: false,
      groups: ["Parents Association"],
    },
    {
      id: "2",
      name: "Mike Johnson",
      avatar: "/images/samples/1280x768/1.jpg",
      role: "Parent",
      status: "offline",
      lastSeen: "Last seen 2 hours ago",
      selected: false,
      groups: ["Parents Association"],
    },
    {
      id: "3",
      name: "Emma Davis",
      avatar: "/images/samples/1280x768/3.jpg",
      role: "Player",
      status: "online",
      selected: false,
      groups: ["Under 20 Soccer Group", "Under 18 Squad"],
    },
    {
      id: "4",
      name: "Coach Martinez",
      avatar: "/images/samples/1280x768/4.jpg",
      role: "Coach",
      status: "online",
      selected: false,
      groups: ["Coaches Team", "Under 20 Soccer Group", "Under 18 Squad"],
    },
  ]

  groups: Group[] = [
    {
      id: "1",
      name: "Under 20 Soccer Group",
      avatar: "/images/samples/group_icon.png",
      memberCount: 5,
      lastActivity: "05:27 PM",
      selected: false,
      description: "Active group with 5 members",
    },
    {
      id: "2",
      name: "Coaches Team",
      avatar: "/images/samples/group_icon.png",
      memberCount: 8,
      lastActivity: "2 days ago",
      selected: false,
      description: "All coaching staff coordination",
    },
    {
      id: "3",
      name: "Parents Association",
      avatar: "/images/samples/group_icon.png",
      memberCount: 25,
      lastActivity: "1 week ago",
      selected: false,
      description: "Parent communication and updates",
    },
    {
      id: "4",
      name: "Under 18 Squad",
      avatar: "/images/samples/group_icon.png",
      memberCount: 12,
      lastActivity: "3 days ago",
      selected: false,
      description: "Under 18 team coordination",
    },
  ]

   // Active states
  activeConversation: Conversation | null = null
  activeTab: "all" | "1-on-1" | "groups" | "queries" = "all"
  activeInfoTab: "media" | "links" | "queries" = "media"
  showMoreInfo = false
  noMoreMessages = false;

  // Search
  searchQuery = ""

  // Message input
  newMessage = ""

  // Data
  conversations: Conversation[] = [
    {
      id: "1",
      name: "Parent Query",
      avatar: "/images/samples/ic_profile.png",
      lastMessage: "Last Message",
      timestamp: new Date("2024-01-15T10:30:00"),
      unreadCount: 0,
      status: "new",
      type: "parent-query",
      default_type: "",
      participants: ["parent1"],
    },
  ]

  messages: Message[] = [
    {
      id: "1",
      senderId: "grace",
      senderName: "Grace Miller",
      senderAvatar: "/images/samples/1280x768/2.jpg",
      content: "Okay",
      timestamp: new Date("2024-01-15T10:35:00"),
      status: "read",
      type: "text",
    },
    {
      id: "2",
      senderId: "grace",
      senderName: "Grace Miller",
      senderAvatar: "/images/samples/1280x768/3.jpg",
      content: "Hi Coach! Thanks for the class. Can't wait for the weekend!",
      timestamp: new Date("2024-01-15T10:38:00"),
      status: "read",
      type: "text",
    },
  ]

  mediaItems: MediaItem[] = [
    {
      id: "1",
      name: "Image1.jpeg",
      type: "image",
      size: "2.1 MB",
      url: "images/icons/logo/dp_black.png",
      timestamp: new Date("2024-01-15T10:30:00"),
      icon: "fas fa-image",
    },
    {
      id: "2",
      name: "Clip1.mp4",
      type: "video",
      size: "15.6 MB",
      url: "images/icons/logo/dp_black.png",
      timestamp: new Date("2024-01-15T10:25:00"),
      icon: "fas fa-video",
    },
  ]

  linkItems: LinkItem[] = [
    {
      id: "1",
      url: "https://www.figma.com/design/YOAqyZPmwSo...",
      title: "Figma Design Link",
      timestamp: new Date("2024-01-15T10:30:00"),
    },
  ]

  queryItems: QueryItem[] = [
    {
      id: "1",
      question: "Is it okay to pay fees directly...",
      status: "in-progress",
      timestamp: new Date("2024-01-15T10:30:00"),
    },
    {
      id: "2",
      question: "Hi Coach, Emma has bee...",
      status: "in-progress",
      timestamp: new Date("2024-01-15T10:25:00"),
    },
    {
      id: "3",
      question: "Kevin is not able to sleep pro...",
      status: "resolved",
      timestamp: new Date("2024-01-15T10:20:00"),
    },
  ]
  conversation_info: any = ""
  participants: Participants[]=[]
  participant: any = {}
  is_loading_conversations = true
  is_loading_messages = true
  is_loading_participant = true
  is_loading_members = true
  is_loading_groups = true
  participantsMap: Map<string, Participants> = new Map();
  saveEditMessage: string = '';

  isEditing = false;
  editedName = '';
  // Jump-to-latest FAB: shown when the user has scrolled up; badge counts messages
  // that arrived while they were away from the bottom.
  showScrollToBottom = false;
  newMessageCount = 0;

  current_page_back = 0;
  prev_page_back = 0;
  total_page = 0;
  filter: any = {
    // selectedUserTypes: {},
    selectedSports: {},
    selectedStatus: {
      "Active": true,
      "Pending Consent": false,
      "Pending Password": true,
    }
  }
  participantIdsInChat: string[] = [];
  hasMore = true; // Track if more pages exist
  scrollTimeout: any;
  deletedUser: any;
  deletedUserMap: Map<string, Participants> = new Map();
  group_id: any = ''
  isDropdownOpen = false;


  // pagination state per conversation
  private currentConversationId = '';
  private nextCursorMap = new Map<string, string>(); // conversationId -> nextCursor
  private hasMoreMap = new Map<string, boolean>();   // conversationId -> hasMore
  private fetchSubscription?: Subscription;
  loadingOlder = false;

  // Optimistic-UI: per-message failure timers keyed by temp_id. If the server
  // ack doesn't arrive within SEND_TIMEOUT_MS the message flips to 'failed'.
  private sendTimers = new Map<string, any>();
  private readonly SEND_TIMEOUT_MS = 15000;

  // groupedMessages = computed(() => {
  //   const msgs = this.state.messagesForActive();
  //   const grouped = this.groupMessages(msgs);

  //   // optional side effect
  //   console.log('Grouped messages updated:', grouped);
  //   return grouped
  // });

  groupedMessages: any[] = [];

  currentView: 'conversations' | 'chat' | 'info' = 'conversations';
  grouped = signal<any[]>([]); // writable signal for template

  attachedFile: File | null = null;
  filePreview: string | null = null;
  fileType: 'image' | 'video' | 'document' | 'other' | null = null;
  isDragOver = false;
  uploadProgress: number = 0;

  uploadFile: Media = {
    url: '',
    type: '',
    mime_type: '',
    size: 0,
    name: '',
    thumb_url: ''
  };

  isAttachmentMenuOpen = false;
  allMessages: any[] = [];

  private searchSubject = new Subject<string>();
  search_empty: boolean = false;
  msg: any;
  typingUsers: TypingUser[] = [];
  /** Precomputed indicator text (empty when nobody is typing). Built in the
   *  typingUsersChanged subscription so the template doesn't compute it per CD cycle. */
  typingLabel = '';

  online : boolean = false

  // Outbound typing state. `typingSent` guards against re-sending startTyping on every
  // keystroke; `sendTypingRefresh` throttles the refresh so we keep the receiver's
  // indicator alive without flooding the socket; `typingTimeout` fires stopTyping on idle.
  typingSent = false;
  typingTimeout?: any;
  sendTypingRefresh: (() => void) & { cancel?: () => void };
  private typingSubs: Subscription[] = [];

  isParticipantsLoaded = false;
  Action = Actions
  Subject = Subjects

  constructor(
    private modalService: NgbModal,
    private storage: StorageService,
    private chat_api: ChatStateService,
    public uploadApi: UploadService,
    private toastr: ToastrService,
    private memberApi: MembersService,
    private datePipe: DatePipe,
    private groupApi: GroupsService,
    private loader: LoaderService,
    public ability: PureAbility<any>,
    private eRef: ElementRef
  ) {
    this.ws.onMessageCreate = (p) => {
      // Own optimistic messages reconcile via onMessageAck; the echo here is deduped
      // by server id inside addMessageFromWs, so it never double-renders.
      const wasNearBottom = this.isUserNearBottom();
      const incoming = (p as any)?.message;
      const incomingConvId = incoming?.conversation_id;
      const senderId = incoming?.sender_id;
      const isActive = !!incomingConvId && incomingConvId === this.activeConversation?.id;
      const isOwn = senderId === this.delegate;
      // The user is effectively "seeing" the message if it lands in the open
      // conversation while they're at the bottom (or it's their own send).
      const viewingLatest = isActive && (wasNearBottom || isOwn);

      this.state.addMessageFromWs(p)
      this.updateGroupedMessages()
      // Keep the active conversation's unread badge at 0 while the user is viewing
      // it — the server's unread_count is still stale until the 'seen' event lands.
      this.reloadConversation(viewingLatest)
      // this.ws.send("who_is_online",{ conversation_id: this.activeConversation?.id });
      // console.log(this.state.messagesForActive())

      if (viewingLatest) {
        // Mark the incoming message seen server-side so the count stays cleared on
        // subsequent reloads. Own messages don't need a seen receipt.
        if (!isOwn && incoming?._id) this.markSeen(incoming._id);
        // Follow the conversation to the newest message.
        setTimeout(() => {
          this.scrollToBottom();
        }, 500);
      } else if (isActive && !isOwn) {
        // Message arrived in the open conversation while the user is scrolled up:
        // surface the jump-to-latest FAB with a new-message count.
        this.newMessageCount++;
        this.showScrollToBottom = true;
      }
    };

    // Optimistic-UI: correlate our sent message with the server's confirmation.
    this.ws.onMessageAck = (ack) => {
      if (ack?.temp_id) this.clearSendTimer(ack.temp_id);
      this.state.reconcileAck(ack);
      this.updateGroupedMessages();
    };
    this.ws.onDelivered = (p) => this.state.markDelivered(p);

    // Connect via the WS token provider (sources the EdDSA access token).
    this.ws.connectWithProvider();
    this.ws.onTyping = (payload) => this.state.handleTyping(payload);
    this.ws.onStopTyping = (payload) => this.state.handleStopTyping(payload);
    this.loadConversation()
    // effect(() => {
    //     this.connectionLabel.set(
    //       this.ws.connected() ? 'Connected' : 'Disconnected'
    //     );
    //   }, { allowSignalWrites: true });

      // log current value
      // console.log(this.connectionLabel());
    //   this.connectionLabel.set(this.ws.connected() ? 'Connected' : 'Disconnected');
    // });
    // console.log(this.connectionLabel, this.ws.connected())

    this.typingSubs.push(
      this.searchSubject.pipe(
        debounceTime(300),           // wait 300ms after typing stops
        distinctUntilChanged()       // only fire if value actually changes
      ).subscribe(value => {
        this.searchUser(value);
      })
    );

    // Leading-edge throttle: emit startTyping at most once every 2s while the user keeps
    // typing. This refreshes the receiver's 5s auto-clear timer without flooding the WS.
    this.sendTypingRefresh = throttle(() => {
      const convId = this.state.activeConversationId();
      if (convId) this.ws.startTyping(convId);
    }, 2000, { leading: true, trailing: false });

//     this.searchSubject.pipe(
//   debounceTime(300),
//   distinctUntilChanged()
// ).subscribe(value => {
//   if (value?.trim()) {
//     this.searchUser(value.trim());
//   } else {
//     this.results = []; // clear list
//     this.loadDefaultList();
//   }
// });
  }

  ngOnInit(): void {
    // Set default active conversation
    this.id = this.storage.getJsonValue(USER_ID)
    this.delegate = this.storage.getJsonValue(DELEGATE_ID) || this.id
    // console.log(this.delegate, this.id)
    this.conversations = []
    this.messages = []
    this.contacts = []
    this.groups = []
    this.checkIfMobile();

    this.typingSubs.push(
      this.state.typingUsersChanged.subscribe(usersMap => {
        const selfIds = [this.id, this.delegate].filter(Boolean);
        this.typingUsers = (usersMap[this.currentConversationId] || [])
          .filter(u => !selfIds.includes(u.id));
        this.typingLabel = this.buildTypingLabel(this.typingUsers);
      })
    );

    this.typingSubs.push(
      this.ws.onlineUsersChanged.subscribe(users => {
        this.participants = this.participants.map(p => ({
          ...p,
          is_online: users.has(p.id)
        }));
      })
    );

    // this.activeConversation = this.conversations[0]
  }

  ngOnDestroy(): void {
    // Clear any in-flight optimistic failure timers.
    this.sendTimers.forEach(t => clearTimeout(t));
    this.sendTimers.clear();

    // Stop advertising typing and tear down typing/online/search subscriptions.
    this.stopTyping();
    this.typingSubs.forEach(s => s.unsubscribe());
    this.typingSubs = [];
  }

  isUrl(text: string): boolean {
    const urlPattern = /^(https?:\/\/[^\s$.?#].[^\s]*)$/i;
    return urlPattern.test(text);
  }

  can(action: Actions, subject: Subjects): boolean {
    return this.ability.can(action, subject);
  }

  canAny(action: Actions, subjects: Subjects[]): boolean {
    return subjects.some(subject => this.ability.can(action, subject));
  }


  async downloadFile(media: { url: string; name?: string }) {
    try {
      const response = await fetch(media.url, {
        mode: 'cors' // Ensure CORS is enabled
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', media.name || 'file');

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the URL to free memory
      URL.revokeObjectURL(link.href);

    } catch (error) {
      console.error('Download failed:', error);
      // You can add logic here to inform the user of the failure
    }
  }



  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkIfMobile();
  }

  private updateGroupedMessages() {
    this.groupedMessages = []
    const msgs = this.state.messagesForActive();
    this.groupedMessages = this.groupMessages(msgs);
    // console.log(this.groupedMessages)
    this.allMessages = this.groupedMessages
      .flatMap(g => g.groups.flatMap((sub: { messages: any[] }) => sub.messages))
      .filter(msg => msg.media && msg.media.length > 0);
    // console.log(this.allMessages, "media only")

  }

  checkIfMobile() {
    this.isMobile = window.innerWidth <= 768;
  }

  isMobileView(): boolean {
    return this.isMobile;
  }

  openChat() {
    this.currentView = 'chat';
  }

  openInfo() {
    if (this.isMobile) {
      this.currentView = 'info';
    } else {
      this.showMoreInfo = true;
    }
  }

  goBack() {
    this.currentView = 'conversations';
  }

    // openChat() {
  //   this.currentView = 'chat';
  // }

  // openInfo() {
  //   this.currentView = 'info';
  // }

  // goBack() {
  //   this.currentView = 'conversations';
  // }

  toggleMoreInfo(): void {
    if (this.isMobile) {
      this.currentView = 'info'; // on mobile, behave like openInfo
    } else {
      this.showMoreInfo = !this.showMoreInfo; // on desktop, toggle side panel
    }
  }

  loadGroups(){
    this.groups = []
    this.groupApi.getGroupsOfId(this.id).subscribe({
      next:(res: any) => {
        if (res['members'] != null) {
          this.is_loading_groups = false

          for (const entry of res['members']) {
            const elem = {
              id: entry['userid'],
              name: entry['user']['basic_information']['name']['first_name'],
              avatar: entry['user']['basic_information']['dp'],
              memberCount: entry['member_count']
            }
            this.groups.push(elem)
          }
          this.groups.forEach(g => {
            const exists = this.conversations.some(c => c.group_id === g.id);
            // console.log(g.name, exists, g.id)
            if (!exists) {
              this.conversations.push({
                id: g.id,
                group_id: g.id,
                name: g.name,
                avatar: g.avatar || "/images/samples/ic_profile.png",
                lastMessage: 'Create chat',
                last_message: {content:'Create chat'},
                timestamp: new Date(),
                unreadCount: 0,
                status: 'new',
                type: 'group',
                default_type: '',
                participants: []
              });
            }
          });
        } else{
          this.is_loading_groups = false
        }
        // this.dtTrigger.next(null);
      }
    })
  }

  reloadConversation(keepActiveRead = false) {
    this.chat_api.fetchListofConversation().subscribe({
      next:(res: any)=>{
        this.is_loading_conversations = false
        if(res.status === SUCCESS && Array.isArray(res.data)){
          this.conversations = res.data.map((message: any)=>({
            id: message.id,
            group_id: message.group_id,
            name: message.title,
            last_message: message.last_message,
            avatar: message.avatar_url,
            lastMessage: "Last Message",
            timestamp: new Date(message?.last_message?.edited_at??message.updated_at),
            unreadCount: message.unread_count ?? 0,
            status: !message.last_message?.seen && message?.last_message?.id !== this.id ?"new":"resolved",
            type: message.type,
            participants: message.participants,
          }))
          // The server's unread_count lags the 'seen' event, so when the user is
          // actively viewing a conversation clear its badge locally right away.
          if (keepActiveRead) {
            this.markActiveConversationRead();
          }
          // console.log(this.conversations)
          this.conversations.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());

        }else{
          this.is_loading_participant = false
          this.is_loading_messages = false
        }
      },
      error:(err: any)=>{
        this.is_loading_conversations = false
      }
    })
  }

  reloadConversation1() {
  this.is_loading_conversations = true;

  this.chat_api.fetchListofConversation().subscribe({
      next: (res: any) => {
        this.is_loading_conversations = false;

        if (res.status !== SUCCESS || !Array.isArray(res.data)) {
          this.is_loading_participant = false;
          this.is_loading_messages = false;
          return;
        }

        this.conversations = res.data
          .map((message: any) => {
            const unreadCount = message.unread_count ?? 0;
            // console.log("Unread count for conversation", message.id, "is", unreadCount);
            return {
              id: message.id,
              group_id: message.group_id,
              name: message.title,
              avatar: message.avatar_url,
              last_message: message.last_message,
              timestamp: new Date(
                message?.last_message?.edited_at ?? message.updated_at
              ),
              unreadCount,
              status: !message.last_message?.seen && message?.last_message?.id !== this.id ?"new":"resolved",
              type: message.type,
              participants: message.participants
            };
          })
          .sort(
            (a: any, b: any) => b.timestamp.getTime() - a.timestamp.getTime()
          );
          // console.log(this.conversations);
        // If currently open conversation is on top → mark as read
        if (
          this.activeConversation &&
          this.conversations.length &&
          this.activeConversation.id === this.conversations[0].id
        ) {
          this.conversations[0].unreadCount = 0;
          this.conversations[0].status = 'resolved';
        }
      },

      error: () => {
        this.is_loading_conversations = false;
      }
    });
  }

  loadConversation(is_load = true) {
    this.chat_api.fetchListofConversation().subscribe({
      next:(res: any)=>{
        this.is_loading_conversations = false
        if(res.status === SUCCESS && Array.isArray(res.data)){
          this.conversations = res.data.map((message: any)=>({
            id: message.id,
            group_id: message.group_id,
            name: message.title,
            last_message: message.last_message,
            avatar: message.avatar_url,
            lastMessage: "Last Message",
            timestamp: new Date(message?.last_message?.edited_at??message.updated_at),
            unreadCount: 0,
            status: !message.last_message?.seen?"new":"resolved",
            type: message.type,
            participants: message.participants,
            default_type: message.default_type,
          }))
          // console.log(this.conversations)
          this.conversations.sort((a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
          if(is_load){
            this.activeConversation = this.conversations[0]
            this.loadConversationInfo(this.conversations[0].id)
            this.loadMessages(this.conversations[0].id)
            this.selectConversation(this.conversations[0])
          }
        }else{
          this.is_loading_participant = false
          this.is_loading_messages = false
        }
      },
      error:(err: any)=>{
        this.is_loading_conversations = false
        this.loadGroups()
        this.loadDefaults()
      },
      complete:()=>{
        this.loadGroups()
        this.loadDefaults()
      }
    })
  }

  loadDefaults(){
    // console.log("load default chats")
    // console.log(this.conversations)
    // this.defaultsChats.forEach((defaultChat: string) => {
    //   const exists = this.conversations.some(c => c.default_type === defaultChat);
    //   if (!exists) {
    //     this.conversations.unshift(
    //       {
    //       id: "",
    //       name: defaultChat.charAt(0).toUpperCase() + defaultChat.slice(1),
    //       avatar: "/images/samples/ic_profile.png",
    //       lastMessage: 'Create chat',
    //       last_message: {content:'Create chat'},
    //       timestamp: new Date(),
    //       unreadCount: 0,
    //       status: 'new',
    //       type: 'group',
    //       default_type: defaultChat,
    //       participants: []
    //     }
    //     )
    //   }
    // })

    // console.log(this.conversations)
  }

  loadConversationInfo(id: string) {
    this.isParticipantsLoaded = false
    this.participants = []
    this.participantsMap = new Map();
    this.chat_api.fetchConversationInfo(id).subscribe({
       next:(res: any)=>{
        this.is_loading_participant = false
        if(res.status === SUCCESS){
          this.conversation_info = res.data
          this.participants = res?.participants?.map((participant: any)=>({
            id: participant.id,
            name: `${participant.basic_information.name.first_name} ${participant.basic_information.name.last_name}`,
            email: `${participant.basic_information.email}`,
            avatar: `${participant.basic_information.dp}`,
            created_at: new Date(),
            basic_information: participant.basic_information,
            profile_type: participant.profile_type ==="Academy"? "Admin": participant.profile_type,
          }))
          // this.activeConversation = this.conversations.find(c=>c.id === id) || null
          this.participantsMap = new Map(
            this.participants.map(p => [p.id, p])
          );
          if(res.data.group_id !=="000000000000000000000000"){
            this.updateParticipantList(res.data.group_id, id)
          }else {
            this.isParticipantsLoaded = true
          }
          this.ws.onlineUsers = new Set()
          this.ws.send("who_is_online",{ conversation_id: this.activeConversation?.id });
          this.participant = ""
          if(this.activeConversation?.type ==='direct'){
            this.participant = this.participants.find((p: any) => p.id !== this.id)?.id;
          }

          // console.log(this.participant )
          // console.log(this.ws.onlineUsers )
        }
      },
      error:()=>{
        this.is_loading_participant = false
        this.is_loading_messages = false
      },
      complete:()=>{
        this.participantIdsInChat = this.participants.map(p => p.id);
        this.loadParticipantNotInChat()
      }
    })
  }

  updateParticipantList(group: any, id: any){
    this.isParticipantsLoaded = false
    this.chat_api.fetchGroupOfficalParticipants(this.id, group).subscribe({
      next:(res: any)=>{
        // console.log(res)
        if(res.status === SUCCESS && Array.isArray(res.data)){
          // const idsSet = new Set(res.data);
          // const objectIds = this.participants.map((obj: any) => obj.id);
          // const objectIdsSet = new Set(objectIds);
          // const isSame = idsSet.size === objectIdsSet.size &&
          //      [...idsSet].every(id => objectIdsSet.has(id));
          // // console.log(isSame)
          // if(!isSame){
          //   const payload = {
          //     "participants": res.data
          //   }
          //   this.chat_api.patchGroupOfficalParticipants(id, payload).subscribe({
          //   next:(res: any)=>{
          //     this.loadConversationInfo(id)
          //   }
          //   })
          // }

          const idsSet = new Set(res.data.map((id: string) => id.toString()));
          const objectIdsSet = new Set(this.participants.map((p: any) => p.id.toString()));

          const isSame = idsSet.size === objectIdsSet.size &&
                        [...idsSet].every(id => objectIdsSet.has(id));

          if (!isSame) {
            const payload = { participants: Array.from(idsSet) };
            this.chat_api.patchGroupOfficalParticipants(id, payload).subscribe({
              next: () => {
                // ✅ Instead of recalling loadConversationInfo directly,
                // just refresh participants once after patch
                this.participants = this.participants.filter(p => idsSet.has(p.id));
                this.participantsMap = new Map(this.participants.map(p => [p.id, p]));
              }
            });
          }
        }
        this.isParticipantsLoaded = true
      },
      error: () => {
        this.isParticipantsLoaded = true
      },
    })
  }

  onScroll(event: any) {
    clearTimeout(this.scrollTimeout);

    this.scrollTimeout = setTimeout(() => {
      const element = event.target;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;

      if (atBottom && !this.is_loading_members && this.hasMore) {
        this.current_page_back++;
        this.loadParticipantNotInChat();
      }
    }, 200);
  }

  onScrollNewConv(event: any) {
    clearTimeout(this.scrollTimeout);

    this.scrollTimeout = setTimeout(() => {
      const element = event.target;
      const atBottom = element.scrollHeight - element.scrollTop <= element.clientHeight + 50;
      // console.log(atBottom, this.hasMore)
      if (atBottom && !this.is_loading_members && this.hasMore) {
        this.current_page_back++;
        this.loadMembers();
      }
    }, 200);
  }

  loadParticipantNotInChat() {
    this.is_loading_members = true; // Set immediately
    const sportsFilter = Object.entries(this.filter.selectedSports)
      .filter(f => f[1])
      .map(p => p[0]);

    const statusFilter = Object.entries(this.filter.selectedStatus)
      .filter(f => f[1])
      .map(p => p[0]);

    const filters = {
      sports: sportsFilter.join(","),
      status: statusFilter.join(",")
    };

    this.memberApi.getMembersByType(
      this.id,
      this.addMemeberTab,
      this.current_page_back.toString(),
      filters.sports,
      filters.status,
      '',
      this.searchTermAdd,
      20,
      this.participantIdsInChat
    ).subscribe({
      next: (res: any) => {
        const newContacts = (res?.members || []).map((member: any) => ({
          id: member?.user?._id,
          name: member?.user?.basic_information?.name.first_name + ' ' + member?.user?.basic_information?.name.last_name,
          avatar: member?.user?.basic_information?.dp || "/images/samples/ic_profile.png",
          role: this.addMemeberTab,
          age: this.getAgeFromDob(member?.user?.basic_information?.dob),
          status: "online"
        }));

        // ✅ Remove duplicates using a Set
        const uniqueContacts = [...this.contacts, ...newContacts].filter(
          (contact, index, self) => index === self.findIndex(c => c.id === contact.id)
        );

        this.contacts = uniqueContacts;

        if (newContacts.length < 15) {
          this.hasMore = false; // No more data
        }

        this.is_loading_members = false;
        // console.log(this.contacts)
      },
      error: () => {
        this.is_loading_members = false;
      }
    });
  }

  getAgeFromDob(dob: string | Date): number {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    const dayDiff = today.getDate() - birthDate.getDate();

    // Adjust if the birthday hasn’t occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
      age--;
    }

    return age;
  }

  loadMembers(is_initial = false) {
    this.is_loading_members = true; // Set immediately
    const sportsFilter = Object.entries(this.filter.selectedSports)
      .filter(f => f[1])
      .map(p => p[0]);

    const statusFilter = Object.entries(this.filter.selectedStatus)
      .filter(f => f[1])
      .map(p => p[0]);

    const filters = {
      sports: sportsFilter.join(","),
      status: statusFilter.join(",")
    };

    this.memberApi.getMembersByTypeForGroup(
      this.id,
      this.group_id,
      this.addMemeberTab,
      this.current_page_back.toString(),
      filters.sports,
      filters.status,
      this.searchTermAdd,
      20
    ).subscribe({
      next: (res: any) => {
        const newContacts = (res?.members || []).map((member: any) => ({
          id: member?.user?._id,
          name: member?.user?.basic_information?.name.first_name + ' ' + member?.user?.basic_information?.name.last_name,
          avatar: member?.user?.basic_information?.dp || "/images/samples/ic_profile.png",
          role: this.addMemeberTab,
          age: this.getAgeFromDob(member?.user?.basic_information?.dob),
          status: "online"
        })).filter((member: any) => member.id !== this.delegate);;
        if(is_initial){
          this.contacts = []
        }
        // console.log(this.addMemeberTab === 'parent' && is_initial, this.addMemeberTab === 'parent' , is_initial)
        if(this.addMemeberTab === 'parent' && is_initial ){
          this.contacts = []
        }
        // ✅ Remove duplicates using a Set
        const uniqueContacts = [...this.contacts, ...newContacts].filter(
          (contact, index, self) => index === self.findIndex(c => c.id === contact.id)
        );
        this.contacts = uniqueContacts;


        if (newContacts.length < 15) {
          this.hasMore = false; // No more data
        }
        // console.log(this.contacts.length, this.contacts)
        // console.log("newContacts:", newContacts)
        // console.log("uniqueContacts:", uniqueContacts)

        this.is_loading_members = false;
      },
      error: () => {
        this.is_loading_members = false;
      }
    });
  }

  loadParents(){
    this.is_loading_members = true; // Set immediately
    this.is_loading_members = true; // Set immediately
    const sportsFilter = Object.entries(this.filter.selectedSports)
      .filter(f => f[1])
      .map(p => p[0]);

    const statusFilter = Object.entries(this.filter.selectedStatus)
      .filter(f => f[1])
      .map(p => p[0]);

    const filters = {
      sports: sportsFilter.join(","),
      status: statusFilter.join(",")
    };

    this.memberApi.getMembersParent(
      this.id,
      this.group_id,
      this.addMemeberTab,
      this.current_page_back.toString(),
      filters.sports,
      filters.status,
      this.searchTermAdd,
      20
    ).subscribe({
      next:(res: any)=>{
        // console.log(res)
       const newContacts = (res || []).map((member: any) => ({
          id: member?._id,
          name: member?.basic_information?.name.first_name + ' ' + member?.basic_information?.name.last_name,
          avatar: member?.basic_information?.dp || "/images/samples/ic_profile.png",
          role: this.addMemeberTab,
          age: this.getAgeFromDob(member?.basic_information?.dob),
          status: "online"
        })).filter((member: any) => member.id !== this.delegate);;

        // ✅ Remove duplicates using a Set
        const uniqueContacts = [...this.contacts, ...newContacts].filter(
          (contact, index, self) => index === self.findIndex(c => c.id === contact.id)
        );
        this.contacts = uniqueContacts;

        // if (newContacts.length < 15) {
          this.hasMore = false; // No more data
        // }
        // console.log(this.contacts.length)
        this.is_loading_members = false;
      },
      error: () => {
        this.is_loading_members = false;
      }
    })
  }

  setGroupFilter(group_id: any) {
    this.isDropdownOpen = false;

    this.group_id = group_id;
    this.selectedGroupFiltername = group_id ? this.getGroupName(group_id) : "all";
    // console.log(this.selectedGroupFiltername)
    this.current_page_back = 0;
    this.prev_page_back = 0;
    this.hasMore = true;
    this.contacts = [];
    this.loadMembers();
  }

    // Helper function to get group name by id
  getGroupName(group_id: any): string {
    if (!group_id || group_id === "all") return "All";
    const group = this.filteredGroups.find(g => g.id === group_id);
    return group ? group.name : "Unknown";
  }

  onImgError(event: any) {
      event.target.src = 'images/samples/ic_profile.png'
  }

  setActiveUnreadTab(tab: "all" | "unread"): void {
    this.activeUnreadTab = tab;
  }

  getUnreadTotal(): number {
    return this.conversations.reduce((count, conv) => count + (conv.unreadCount > 0 ? 1 : 0), 0);
  }

  openMediumModal(mediumModalContent: any, modal?: any) {
    // console.log(this.sessions)
    this.modalReference = this.modalService.open(mediumModalContent, { windowClass: "viewSchedules" });
    this.modalReference.result.then(() => {
      //
    });
  }

  onStartChat() {
    if (this.selectedContacts.length === 0) return;

    // One-to-one chat
    if (this.selectedContacts.length === 1) {
      const contact = this.selectedContacts[0];

      const newConversation : Conversation = {
        id: Date.now().toString(),
        name: contact.name, // Use contact's display name
        avatar: contact.avatar || "/images/samples/ic_profile.png",
        lastMessage: "",
        timestamp: new Date(),
        unreadCount: 0,
        status: "new",
        type: this.mapRoleToConversationType(contact.role), // map role
        default_type: "",
        participants: [contact.id] // keep reference to participant
      };

      this.conversations.unshift(newConversation);
    }
    // Group chat
    else {
      const names = this.selectedContacts.map(c => c.name).join(", ");

      const newConversation : Conversation = {
        id: Date.now().toString(),
        name: names.length > 30 ? names.substring(0, 30) + "..." : names,
        avatar: "/images/samples/group_icon.png", // generic group icon
        lastMessage: "",
        timestamp: new Date(),
        unreadCount: 0,
        status: "new",
        type: "group",
        default_type: "",
        participants: this.selectedContacts.map(c => c.id)
      };

      this.conversations.unshift(newConversation);
    }

    // Reset selections
    this.resetSelection()
  }

  private mapRoleToConversationType(role: string): "1-on-1" | "parent-query" | "group" {
    switch (role.toLowerCase()) {
      case "parent":
        return "parent-query";
      case "player":
        return "1-on-1";
      default:
        return "1-on-1"; // fallback
    }
  }

  // get filteredContacts(): Contact[] {
  //   if (!this.searchTerm.trim()) {
  //     return this.contacts
  //   }
  //   return this.contacts.filter(
  //     (contact) =>
  //       contact.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
  //       contact.role.toLowerCase().includes(this.searchTerm.toLowerCase()),
  //   )
  // }

  get selectedContacts(): Contact[] {
    return this.contacts.filter((contact) => contact.selected)
  }

  get selectedCount(): number {
    return this.selectedContacts.length
  }

  onClose(): void {
    this.resetSelection()
  }

  private resetSelection(): void {
    this.contacts.forEach((contact) => (contact.selected = false))
    this.searchTerm = ""
  }


  getRoleIcon(role: string): string {
    switch (role.toLowerCase()) {
      case "parent":
        return "bi-person-fill"
      case "player":
        return "bi-person-circle"
      case "coach":
        return "bi-people"
      default:
        return "bi-person"
    }
  }

  getRoleColor(role: string): string {
    switch (role.toLowerCase()) {
      case "parent":
        return "text-primary"
      case "player":
        return "text-success"
      case "coach":
        return "text-warning"
      default:
        return "text-secondary"
    }
  }

  // Conversation methods
  selectConversation(conversation: Conversation): void {
    this.activeConversation = null
    // console.log(conversation.default_type, "select conversation", conversation)
    // console.log(conversation.default_type != undefined && conversation.default_type && conversation.default_type !=="")
    if(conversation.id === conversation.group_id) {
      // console.log("Group chat selected, loading group details...")
      const payload = {
          "group_ids":[conversation.group_id],
          "avatar_url":conversation.avatar,
          "title":conversation.name,
          "group_id":conversation.group_id,
          "type":"group"
      }
      // this.currentView = 'conversations';
      this.loader.show()
      this.chat_api.createConversationWithGroupOffical(this.id, payload).subscribe({
        next: (res: any) => {
          this.loader.hide()
          if (res.status === SUCCESS) {
            // const convid = res.data.id
            // // conversation.id = convid
            // if (this.activeConversation) {
            //   this.activeConversation.name = res.data.title;
            //   this.activeConversation.avatar = res.data.avatar_url;
            //   this.activeConversation.group_id = res.data.group_id;
            //   this.activeConversation.type = res.data.type;
            //   this.activeConversation.id = res.data.id;
            //   this.activeConversation.participants = res.data.participants;
            // }
            // // Load messages for this conversation
            // this.loadConversationInfo(convid)
            // this.loadMessages(convid)
            this.loadConversation(false)
            this.currentView = 'conversations';
            this.toastr.success(`New conversation have been created.`, 'Conversation Created', {
              progressBar: true,
              closeButton: true,
            })
            const conv: Conversation = {
              id: res.data.id,
              name: res.data.title,
              avatar: res.data.avatar_url,
              lastMessage: '',
              timestamp: new Date(),
              unreadCount: 0,
              status: 'resolved',
              type: res.data.type,
              default_type: "",
              participants: res.data.participants
            }
            this.activeConversation = conv
            this.loadConversationInfo(conv.id)
            this.loadMessages(conv.id)
            // console.log("conv:", conv)
            // this.closeModal()
            // this.loadConversation()
          }
        }, error: (err: any) => {
          // Handle error
          this.loader.hide()
        }
      })
    }
    else if(conversation.default_type != undefined && conversation.default_type && conversation.default_type !=="" && conversation.id ===""){
      // console.log("Default chat selected, loading default chat...")
      const payload = {
        "avatar_url":conversation.avatar,
        "title":conversation.name,
        "group_id":conversation.group_id,
        "type":"group",
        "default_type":conversation.default_type,
      }
      //  console.log(payload)
      // return
      this.chat_api.createConversationDefault(this.id, payload).subscribe({
        next: (res: any) => {
           this.loadConversation(false)
            this.currentView = 'conversations';
            this.toastr.success(`New conversation have been created.`, 'Conversation Created', {
              progressBar: true,
              closeButton: true,
            })
            const conv: Conversation = {
              id: res.data.id,
              name: res.data.title,
              avatar: res.data.avatar_url,
              lastMessage: '',
              timestamp: new Date(),
              unreadCount: 0,
              status: 'resolved',
              type: res.data.type,
              default_type: "",
              participants: res.data.participants
            }
            this.activeConversation = conv
            this.loadConversationInfo(conv.id)
            this.loadMessages(conv.id)
            this.openChat()
        }
      })
    }
    else{
      this.activeConversation = conversation
      conversation.status = "resolved"
      conversation.unreadCount = 0
      // console.log(conversation)
      // console.log("active:", this.activeConversation)
      // Load messages for this conversation
      if(conversation.default_type !== ""){
        // console.log("default type chat selected")
        this.chat_api.patchConversationDefault(this.id).subscribe({
          next: (res: any) => {
            // console.log(res)
          }
        })
      }
      this.loadConversationInfo(conversation.id)
      this.loadMessages(conversation.id)
      this.openChat()
    }
  }

  loadMessages(conversationId: string, initial = true): void {
    // Stop advertising typing in the conversation we're leaving.
    this.stopTyping();
    this.groupedMessages = []
    // Reset the jump-to-latest FAB so it doesn't linger from the previous chat.
    this.showScrollToBottom = false;
    this.newMessageCount = 0;
    // In real app, this would load messages from API
    this.currentConversationId = conversationId;
    this.state.setActiveConversation(conversationId)
    // If initial load, show main loader; otherwise show loadingOlder spinner
    if (initial) {
      this.is_loading_messages = true;
    } else {
      this.loadingOlder = true;
    }
    this.chat_api.fetchMessagesOfConversation(conversationId, undefined).subscribe({
      next:(res: any)=>{
        this.is_loading_messages = false
        this.loadingOlder = false;
        if(res.status === SUCCESS && Array.isArray(res.data)){
            // console.log(res.data)
          this.messages = res.data.map((message: any)=>({
            id: message.id,
            conversation_id: conversationId,
            sender_id: message.sender_id,
            senderId: message.sender_id,
            senderName: message.sender_id,
            senderAvatar: "/images/samples/1280x768/3.jpg",
            content: message.content,
            timestamp: new Date(message.updated_at),
            status: "delivered",
            type: message.type,
            seq: message.seq,
            edited: message.edited,
            deleted: message.deleted,
            delivered: message.delivered,
            created_at: new Date(message.updated_at),
            updated_at: new Date(message.updated_at),
            is_editing : false,
            media: message.media ?? [],
            seen_by: message?.seen_by ?? []
          }))
          // this.messages.sort((a: any, b: any) => a.seq - b.seq);
          const msgs: ChatMessage[] = this.messages.map((msg: any) => ({
            id: msg.id,
            conversation_id: msg.conversation_id ?? conversationId,
            sender_id: msg.sender_id ?? msg.senderId,
            senderId: msg.senderId,
            senderName: msg.senderName,
            senderAvatar: msg.senderAvatar,
            content: msg.content,
            timestamp: msg.timestamp,
            status: msg.status,
            type: msg.type,
            seq: msg.seq,
            edited: msg.edited ?? false,
            deleted: msg.deleted ?? false,
            delivered: msg.delivered ?? false,
            created_at: msg.created_at ?? msg.timestamp,
            updated_at: msg.updated_at ?? msg.timestamp,
            is_editing : false,
            media: msg.media ?? [],
            seen_by: msg?.seen_by ?? []
          }))
          this.state.messagesByConv.update(map => {
            const next = new Map(map);
            next.set(conversationId, msgs.sort((a: any, b: any) => a.seq - b.seq));
            return next;
          });
           // set pagination metadata
          this.nextCursorMap.set(conversationId, res.nextCursor || '');
          this.hasMoreMap.set(conversationId, !!res.hasMore);
          // this.groupMessages(this.state.messagesForActive());
          this.updateGroupedMessages()
          setTimeout(() => {
            // console.log("scroll to view")
            this.scrollToBottom(false);
          }, 500);
        }else{
          this.groupedMessages = []
        }
      },
      error:()=>{
        this.is_loading_messages = false;
        this.loadingOlder = false;
        this.groupedMessages = []
      },
      complete:()=>{
        // console.log("Completed loading messages for", this.state.messagesForActive())
        const missingIds = [...new Set(this.state.messagesForActive().map((m: any) => m.senderId).filter(id => !this.participantsMap.has(id)))];
        if (missingIds.length > 0) {
          const payload={
            participants: missingIds,
          }
          this.chat_api.fetchParticipantsByIds(conversationId,payload).subscribe({
            next:(res: any)=>{
              if(res.status === SUCCESS && Array.isArray(res.data)){
                this.deletedUser = res.data.map((member: any)=>({
                    id: member?.id,
                    name: member?.basic_information?.name.first_name + ' ' + member?.basic_information?.name.last_name,
                    avatar: member?.basic_information?.dp || "/images/samples/ic_profile.png",
                }))

                this.deletedUserMap = new Map(
                  this.deletedUser.map((p: any) => [p.id, p])
                );
                // console.log(this.deletedUserMap, this.deletedUser)
              }
            }
          })
        }
      }
    })
  }

  // -----------------------
  // Scroll handler - attached on container via (scroll)
  // -----------------------
  private scrollThreshold = 120; // px from top to trigger load (tune as needed)

  onScrollMessage(): void {
    // when user scrolls up near top, load older messages
    const el = this.chatContainer?.nativeElement;
    if (!el) return;

    // If already at top and more to load and not loading, load older
    if (el.scrollTop <= this.scrollThreshold && this.canLoadOlder()) {
      this.loadOlderPreservingAnchor();
    }

    // Toggle the jump-to-latest FAB based on how far the user is from the bottom.
    const nearBottom = this.isUserNearBottom();
    if (nearBottom) {
      if (this.showScrollToBottom) this.showScrollToBottom = false;
      if (this.newMessageCount) this.newMessageCount = 0; // caught up
      // Reaching the bottom (by button or manual scroll) means the user has seen
      // the latest — dismiss the sidebar unread bubble too.
      this.markActiveConversationRead();
    } else if (!this.showScrollToBottom) {
      this.showScrollToBottom = true;
    }
  }

  /** Smooth-scroll to the newest message and reset the jump-to-latest FAB. */
  jumpToLatest(): void {
    this.scrollToBottom(true);
    this.showScrollToBottom = false;
    this.newMessageCount = 0;
    // Messages scrolling into view fire (seen) which syncs the server; also clear
    // the sidebar unread bubble locally so it dismisses immediately.
    this.markActiveConversationRead();
  }

  /** Clear the active conversation's sidebar unread badge locally. */
  private markActiveConversationRead(): void {
    if (!this.activeConversation) return;
    const active = this.conversations.find(c => c.id === this.activeConversation!.id);
    if (active) {
      active.unreadCount = 0;
      active.status = "resolved";
    }
  }

  // -----------------------
  // Load older messages (prepend) and preserve visible anchor
  // -----------------------
  async loadOlderPreservingAnchor(): Promise<void> {
    if (!this.currentConversationId) return;
    if (!this.canLoadOlder()) return;

    const conversationId = this.currentConversationId;
    const lastId = this.nextCursorMap.get(conversationId);
    if (!lastId) {
      // nothing to load
      this.noMoreMessages = true;
      this.hasMoreMap.set(conversationId, false);
      return;
    }

    // this.cancelInflightFetch();
    this.loadingOlder = true;

    const el = this.chatContainer.nativeElement;
    const prevScrollHeight = el.scrollHeight;
    const prevScrollTop = el.scrollTop;

    // console.log(`Loading older messages for ${conversationId} before ${lastId}...`);
    this.fetchSubscription = this.chat_api.fetchMessagesOfConversation(conversationId, lastId)
      .subscribe({
        next: (page: any) => {
          // page.messages is oldest->newest of that chunk
          const newMsgs = (page.data || []).map((message: any) => ({
            id: message._id || message.id,
            conversation_id: conversationId,
            sender_id: message.sender_id,
            senderId: message.sender_id,
            senderName: message.senderName || message.sender_id,
            senderAvatar: message.senderAvatar || "/images/samples/1280x768/3.jpg",
            content: message.content,
            timestamp: message.updated_at ? new Date(message.updated_at) : new Date(),
            status: message.status || 'delivered',
            type: message.type,
            seq: message.seq,
            edited: message.edited,
            deleted: message.deleted,
            delivered: message.delivered,
            created_at: message.created_at ? new Date(message.created_at) : new Date(),
            updated_at: message.updated_at ? new Date(message.updated_at) : new Date(),
            is_editing: false
          }));

          // If no messages returned, mark hasMore false
          if (!newMsgs.length) {
            this.hasMoreMap.set(conversationId, false);
            this.nextCursorMap.set(conversationId, '');
            this.loadingOlder = false;
            this.noMoreMessages = true;
            return;
          }

          // Dedupe: avoid inserting messages already present
          const existing = this.state.messagesByConv().get(conversationId) || [];
          const existingIds = new Set(existing.map(m => m.id));
          const deduped = newMsgs.filter((m: any) => !existingIds.has(m.id));

          // Prepend deduped messages preserving order: older -> ... -> newest (we want older first)
          if (deduped.length) {
            this.state.messagesByConv.update(map => {
              const next = new Map(map);
              const merged = [...deduped, ...(next.get(conversationId) || [])];
              next.set(conversationId, merged);
              return next;
            });
          }

          // update pagination meta
          this.hasMoreMap.set(conversationId, !!page.hasMore);
          this.nextCursorMap.set(conversationId, page.nextCursor || '');
          this.noMoreMessages = !page.hasMore;
          this.updateGroupedMessages()
          // console.log(`Loaded ${deduped.length} older messages for ${conversationId}, hasMore=${page.hasMore}`);
          // console.log(this.state.messagesForActive() );
          // After DOM update, compute scroll delta and restore visible area
          setTimeout(() => {
            const newScrollHeight = el.scrollHeight;
            const delta = newScrollHeight - prevScrollHeight;
            // Ensure scrollTop doesn't exceed limits
            el.scrollTop = Math.max(0, prevScrollTop + delta);
            this.loadingOlder = false;
          }, 40); // small timeout to let angular render DOM
        },
        error: () => {
          this.loadingOlder = false;
        }
      });
  }


  // -----------------------
  // trackBy
  // -----------------------
  trackByMessageId(_: number, m: any) {
    // Prefer temp_id so the DOM node stays stable when an optimistic message's id
    // is swapped from temp_id -> server id on ack (no flicker, keeps the element).
    return m?.temp_id ?? m?.id ?? m?._id ?? _;
  }

  private canLoadOlder(): boolean {
    if (!this.currentConversationId) return false;
    if (this.loadingOlder || this.is_loading_messages) return false;
    return !!this.hasMoreMap.get(this.currentConversationId);
  }

  private isUserNearBottom(): boolean {
    const container = this.chatContainer.nativeElement;
    const threshold = 150; // px from bottom
    const position = container.scrollTop + container.clientHeight;
    return container.scrollHeight - position <= threshold;
  }

  // Tab methods
  setActiveTab(tab: "all" | "1-on-1" | "groups" | "queries"): void {
    this.activeTab = tab
  }

  setActiveInfoTab(tab: "media" | "links" | "queries"): void {
    this.activeInfoTab = tab
  }

  // Message methods
  sendMessage(): void {
    const hasText = !!this.newMessage.trim();
    const hasMedia = this.uploadFile.type !== '' && this.uploadFile.url !== '';
    if (!this.activeConversation || (!hasText && !hasMedia)) return;

    const convId = this.state.activeConversationId();
    if (!convId) return;

    // We're sending — stop advertising "typing" right away.
    this.stopTyping();

    const content = this.newMessage.trim();
    const type = this.uploadFile.type === '' ? 'text' : this.uploadFile.type;
    const media = hasMedia ? [this.uploadFile] : [];
    const temp_id = crypto.randomUUID();

    // 1) Render instantly from a client-side optimistic record (status: 'sending').
    this.state.addOptimisticMessage(convId, {
      temp_id,
      sender_id: this.delegate,
      content,
      type,
      media,
    });
    this.updateGroupedMessages();

    // 2) Fire over the socket with the temp_id so the server can echo it in message_ack.
    this.dispatchMessage(temp_id, { conversation_id: convId, content, temp_id, type, media });

    // 3) Reset the composer and always follow our own message to the bottom.
    this.attachedFile = null;
    this.filePreview = null;
    this.fileType = null;
    this.uploadFile = { url: '', type: '', mime_type: '', size: 0, name: '', thumb_url: '' };
    this.uploadProgress = 0;
    setTimeout(() => {
      this.newMessage = "";
      this.scrollToBottom();
    }, 0);
  }

  /** Send (or resend) a message payload over the socket and arm the failure timer. */
  private dispatchMessage(tempId: string, payload: any): void {
    const media = payload.media && payload.media.length ? payload.media : undefined;
    const wsPayload: any = {
      conversation_id: payload.conversation_id,
      content: payload.content,
      temp_id: tempId,
      type: payload.type,
    };
    if (media) wsPayload.media = media;
    this.ws.send(message_options.send_message, wsPayload);
    this.armSendTimer(tempId);
  }

  private armSendTimer(tempId: string): void {
    this.clearSendTimer(tempId);
    this.sendTimers.set(tempId, setTimeout(() => {
      this.state.markMessageFailed(tempId);
      this.updateGroupedMessages();
      this.sendTimers.delete(tempId);
    }, this.SEND_TIMEOUT_MS));
  }

  private clearSendTimer(tempId: string): void {
    const t = this.sendTimers.get(tempId);
    if (t) { clearTimeout(t); this.sendTimers.delete(tempId); }
  }

  /** Retry a failed message, reusing the same optimistic record / temp_id. */
  retryMessage(message: any): void {
    const tempId = message?.temp_id;
    if (!tempId || message.status !== 'failed') return;
    this.state.retryOptimisticMessage(tempId);
    this.updateGroupedMessages();
    this.dispatchMessage(tempId, {
      conversation_id: message.conversation_id ?? this.state.activeConversationId(),
      content: message.content,
      type: message.type,
      media: message.media ?? [],
    });
  }

  /** Remove a failed message from the UI (never silently drop). */
  deleteFailedMessage(message: any): void {
    const tempId = message?.temp_id;
    if (!tempId) return;
    this.clearSendTimer(tempId);
    this.state.removeMessage(tempId);
    this.updateGroupedMessages();
  }

  markSeen(msgId: string) {
    // console.log("Marking message as seen:", msgId);
    this.ws.send("seen", { msg_id: msgId });
  }

  onSeen(msgId: string, msg: any) {
    if(msg?.seen_by?.includes(this.delegate)){
      return
    }
    // console.log(msg)
    this.markSeen(msgId); // sends WS {op: "seen", d: {msg_id}}
  }

  markRead(msgId: string) {
    this.ws.send("read", { msg_id: msgId });
  }

  onInput() {
    this.onTyping();
  }

  // Fired on every keystroke. Emits startTyping immediately on the first keystroke
  // (leading throttle), keeps refreshing it every ~2s while typing, and (re)arms an
  // idle timer that sends stopTyping after ~2.5s of no keystrokes.
  onTyping() {
    this.typingSent = true;
    this.sendTypingRefresh();

    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => this.stopTyping(), 2500);
  }

  onTypingStop() {
    this.stopTyping();
  }

  // Immediately end the outbound typing state. Safe to call repeatedly.
  private stopTyping() {
    clearTimeout(this.typingTimeout);
    this.sendTypingRefresh.cancel?.();
    if (!this.typingSent) return;
    this.typingSent = false;
    const convId = this.state.activeConversationId();
    if (convId) this.ws.stopTyping(convId);
  }

  // Build the indicator text for the active conversation. DMs show a generic "typing…"
  // (you already know who you're talking to); groups name the typers.
  private buildTypingLabel(users: TypingUser[]): string {
    if (!users.length) return '';
    if (this.activeConversation?.type === 'direct') return 'typing…';

    const nameOf = (u: TypingUser) =>
      u.name || this.participantsMap.get(u.id)?.name || 'Someone';
    if (users.length === 1) return `${nameOf(users[0])} is typing…`;
    if (users.length === 2) return `${nameOf(users[0])} and ${nameOf(users[1])} are typing…`;
    return 'Several people are typing…';
  }

  onEnterPress(event: any) {
    if (!event.shiftKey) {
      event.preventDefault(); // prevent newline
      this.sendMessage();    // send the message
    }
  }

  scrollToBottom(is_smooth = true): void {
    try {
      if(is_smooth){
        this.chatContainer.nativeElement.scrollTo({
          top: this.chatContainer.nativeElement.scrollHeight,
          behavior: 'smooth'
        });
      }else{
        this.chatContainer.nativeElement.scrollTo({
          top: this.chatContainer.nativeElement.scrollHeight,
        });
      }

    } catch (err) {}
  }

  // Utility methods
  formatTime(date: Date): string {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
    })
  }

  getFilteredConversations(): Conversation[] {
    // console.log("hi")
    this.search_empty = false
    let filtered = this.conversations;

    if (this.activeTab !== "all") {
      filtered = filtered.filter((conv) => {
        switch (this.activeTab) {
          case "1-on-1":
            return conv.type === "direct";
          case "groups":
            return conv.type === "group";
          case "queries":
            return conv.type === "parent-query";
          default:
            return true;
        }
      });
    }

    if (this.activeUnreadTab === "unread") {
      filtered = filtered.filter((conv) => conv.unreadCount > 0);
    }

    if (this.searchQuery) {
      filtered = filtered.filter((conv) => conv.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
      this.search_empty = true
    }
    // console.log(filtered)
    return filtered;
  }

  getStatusBadgeClass(status: string): string {
    switch (status) {
      case "new":
        return "status-new"
      case "in-progress":
        return "status-progress"
      case "resolved":
        return "status-resolved"
      default:
        return ""
    }
  }



  markAsResolved(): void {
    if (this.activeConversation) {
      this.activeConversation.status = "resolved"
    }
  }

  escalateQuery(): void {
    console.log("Escalating query to coach")
  }

  // Modal management
  openNewChatModal() {
    this.onSearchChange('')
    this.resetState()
    this.loadMembers()
    this.currentStep = "selection"
    this.currentModal = this.modalService.open(this.chatModal, {
      size: "md",
      backdrop: "static",
      keyboard: false,
    })
  }

  closeModal() {
    if (this.currentModal) {
      this.currentModal.dismiss()
      this.currentModal = null
    }
    this.currentStep = "selection"
    // this.onClose.emit()
  }

  // Tab management
  setActiveTabpop(tab: "contacts" | "groups") {
    this.activeTabpop = tab
    this.searchTerm = ""
    this.resetSelections()
  }

  setActiveMembersTabpop(tab: any) {
    this.addMemeberTab = tab
    this.searchTerm = ""
    this.current_page_back = 0
    this.contacts = []
    this.is_loading_members = true
    this.hasMore = true

    if(tab === 'parent'){
      this.loadMembers()
    }else{
      this.loadParticipantNotInChat()
    }
    this.resetSelections()
  }

  // loadParents(){
  //   this.
  // }

  setNewChatMembersTabpop(tab: any) {
    this.addMemeberTab = tab
    this.searchTerm = ""
    this.searchTermAdd = ""
    this.onSearchChange(this.searchTerm)
    this.current_page_back = 0
    this.contacts = []
    this.is_loading_members = true
    this.hasMore = true
    // if(tab === 'parent'){
    //   this.loadParents()
    // }else{
      this.loadMembers(true)
    // }
    this.resetSelections()
  }

  searchTermAddMemeber(){
    this.current_page_back = 0
    this.contacts = []
    this.is_loading_members = true
    this.hasMore = true

    if(this.addMemeberTab === 'parent'){
      this.loadMembers(true)
    }else{
      this.loadParticipantNotInChat()
    }
  }

  // Contact/Group selection
  toggleContactSelection(contact: any) {
    if(contact.age <=13){
      this.toastr.warning(`The member is under the age of 13. They cannot be added to any chats`,`Action blocked!`)
      return
    }
    contact.selected = !contact.selected
  }

  toggleGroupSelection(group: Group) {
    group.selected = !group.selected
  }

  // Filtering
  get availableGroups(): string[] {
    const allGroups = new Set<string>()
    this.contacts.forEach((contact) => {
      contact.groups?.forEach((group) => allGroups.add(group))
    })
    return Array.from(allGroups)
  }


  get filteredContacts(): Contact[] {
    let filtered = this.contacts

    // console.log(this.selectedGroupFilter)
    // Apply group filter
    if (this.selectedGroupFilter !== "all") {
      filtered = filtered.filter((contact) => contact.groups?.includes(this.selectedGroupFilter))
    }

    // Apply search filter
    if (this.searchTerm.trim()) {
      filtered = filtered.filter(
        (contact) =>
          contact.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
          contact.role.toLowerCase().includes(this.searchTerm.toLowerCase()) || this.addMemeberTab === 'parent'
      )
    }
    // if(this.addMemeberTab === 'parent'){
    //   filtered = this.contacts
    // }
    // console.log(this.contacts, filtered, this.searchTerm)
    return filtered
  }

  // searchUser(value: string){
  //   // console.log('Searching for:', value);
  //   this.searchTermAdd = value
  //   if(value.length > 0){
  //     this.current_page_back = 0
  //     this.loadMembers(true)
  //   }else{
  //     this.hasMore = true
  //   }
  // }

  searchUser(value: string) {
    this.searchTermAdd = value;

    if (value && value.trim().length > 0) {
      // 🔹 New search
      this.current_page_back = 0;
      this.loadMembers(true);
    } else {
      // 🔹 Clear search
      this.hasMore = true;
      this.current_page_back = 0;

      // Option 2: Reload default (all members list)
      this.contacts = []
      this.loadMembers(false);
    }
  }


  onSearchChange(value: string) {
    this.searchSubject.next(value);
  }

  get filteredGroups(): Group[] {
    // return this.groups
    if (!this.searchTerm.trim()) {
      return this.groups
    }
    return this.groups.filter((group) => group.name.toLowerCase().includes(this.searchTerm.toLowerCase()))
  }

  // Selection counts
  get selectedContactCount(): number {
    return this.contacts.filter((c) => c.selected).length
  }

  get selectedGroupCount(): number {
    return this.groups.filter((g) => g.selected).length
  }

  get totalSelectedCount(): number {
    return this.activeTabpop === "contacts" ? this.selectedContactCount : this.selectedGroupCount
  }

  // Actions
  onCreateGroupChat() {

    if (this.activeTabpop === "contacts" && this.selectedContactCount > 1) {
      // Prepare for group setup
      this.selectedParticipants = this.contacts.filter((c) => c.selected)
      this.groupName = `Group with ${this.selectedParticipants.map((p) => p.name).join(", ")}`
      // Navigate to setup step within same modal
      this.currentStep = "setup"
    } else {
      // Handle single contact or group selection
      this.groupedMessages = []
      this.handleChatCreation()
    }
  }

  goToStep(step: "selection" | "setup") {
    this.currentStep = step
  }

  handleChatCreation() {
    let chatData

    if (this.activeTabpop === "contacts") {
      const selectedContacts = this.contacts.filter((c) => c.selected)
      chatData = {
        type: selectedContacts.length === 1 ? "individual" : "group",
        participants: selectedContacts,
        name: selectedContacts.length === 1 ? selectedContacts[0].name : this.groupName,
      }
      const payload= {
        type:selectedContacts.length === 1 ? "direct" : "group",
        title:selectedContacts.length === 1 ? selectedContacts[0].name : this.groupName,
        avatar_url:"",
        participant_id:selectedContacts.map(c => c.id)[0],
        participant_ids:selectedContacts.map(c => c.id),
      }

      this.chat_api.createConversation(payload).subscribe({
        next: (res: any) => {
          if (res.status === SUCCESS) {
            this.toastr.success(`New conversation have been created.`, 'Conversation Created', {
              progressBar: true,
              closeButton: true,
            })
            const conv: Conversation = {
              id: res.data.id,
              name: res.data.title,
              avatar: res.data.avatar_url,
              lastMessage: '',
              timestamp: new Date(),
              unreadCount: 0,
              status: 'new',
              type: res.data.type,
              default_type: "",
              participants: res.data.participants
            }
            this.loadConversation(false)
            this.activeConversation = conv
            // Load messages for this conversation
            // console.log(conv)
            this.loadConversationInfo(conv.id)
            this.loadMessages(conv.id)
          }
        }, error: (err: any) => {
          // Handle error
        }
      })
    } else {
      const selectedGroups = this.groups.filter((g) => g.selected)
      chatData = {
        type: "existing-group",
        groups: selectedGroups,
      }
      // console.log("Existing group chat selected:", selectedGroups)
      this.groupName = `Group with ${selectedGroups.map((p) => p.name).join(", ")}`
      const payload = {
          "group_ids":selectedGroups.map((p) => p.id),
          "avatar_url":"",
          "title":this.groupName,
          "type":"group"
      }
      this.chat_api.createConversationWithGroup(this.id, payload).subscribe({
        next: (res: any) => {
          if (res.status === SUCCESS) {
            this.toastr.success(`New conversation have been created.`, 'Conversation Created', {
              progressBar: true,
              closeButton: true,
            })
            this.closeModal()
            this.loadConversation(false)
            const conv: Conversation = {
              id: res.data.id,
              name: res.data.title,
              avatar: res.data.avatar_url,
              lastMessage: '',
              timestamp: new Date(),
              unreadCount: 0,
              status: 'new',
              type: res.data.type,
              default_type: "",
              participants: res.data.participants
            }
            this.activeConversation = conv
            this.loadConversationInfo(conv.id)
            this.loadMessages(conv.id)
            // console.log(conv)
          }
        }, error: (err: any) => {
          // Handle error
        }
      })
    }

    this.onChatCreated.emit(chatData)
    this.closeModal()
  }

  async onGroupPhotoUpload(event: any) {
    const file = event.target.files[0]
    if (file) {
      var filepath = `${this.id}/conversations/${this.id || 'general'}/images/${new Date().getTime()}_DART`;
      filepath = filepath.replace(/ /g, "_");
      const upload_status = await this.uploadApi.azureupload(file, storage_user, container_user, filepath)
      this.groupPhoto =  upload_status.uploadpath
    }
  }

  removeParticipant(participant: Contact) {
    this.selectedParticipants = this.selectedParticipants.filter((p) => p.id !== participant.id)
    // Also unselect from contacts
    const contact = this.contacts.find((c) => c.id === participant.id)
    if (contact) contact.selected = false
  }

  removeParticipantFromConversation(participant: Participants) {
    this.state.removeParticipantFromConversation(this.activeConversation?.id || '', participant.id).subscribe({
      next: (res: any) => {
        if (res.status === SUCCESS) {
          this.toastr.success(`'${participant.name}' has been removed from the conversation.`, 'Participant Removed', {
            progressBar: true,
            closeButton: true,
          })
          this.loadConversationInfo(this.activeConversation?.id || '')
        }
      }, error: (err: any) => {
        // Handle error
      }
    })
  }

  createGroups() {
    const groupData = {
      type: "new-group",
      name: this.groupName,
      photo: this.groupPhoto,
      participants: this.selectedParticipants,
    }

    const payload= {
      type: "group",
      title:this.groupName,
      avatar_url:this.groupPhoto,
      participant_ids:this.selectedParticipants.map(c => c.id),
    }
     this.groupedMessages = []
    this.chat_api.createConversation(payload).subscribe({
      next: (res: any) => {
        if (res.status === SUCCESS) {
          this.toastr.success(`New conversation have been created.`, 'Conversation Created', {
            progressBar: true,
            closeButton: true,
          })
          this.onChatCreated.emit(groupData)
          this.closeModal()
          this.loadConversation(false)
          const conv: Conversation = {
            id: res.data.id,
            name: res.data.title,
            avatar: res.data.avatar_url,
            lastMessage: '',
            timestamp: new Date(),
            unreadCount: 0,
            status: 'new',
            type: res.data.type,
            default_type: "",
            participants: res.data.participants
          }
          this.activeConversation = conv
          this.activeConversation.group_id = '000000000000000000000000'
          this.loadConversationInfo(conv.id)
          this.loadMessages(conv.id)
          console.log(conv)
        }
      }, error: (err: any) => {
        // Handle error
      }
    })

  }

  backToContactSelection() {
    this.currentStep = "selection"
  }

  // Utility methods
  resetState() {
    this.activeTabpop = "contacts"
    this.searchTerm = ""
    this.selectedGroupFilter = "all"
    this.selectedGroupFiltername = "All"
    this.currentStep = "selection"
    this.resetSelections()
  }

  resetSelections() {
    this.contacts.forEach((c) => (c.selected = false))
    this.groups.forEach((g) => (g.selected = false))
  }

  enableEdit() {
    this.isEditing = true;
    this.editedName = this.activeConversation?.name || '';
  }

  confirmEdit() {
    if (this.editedName.trim()) {
      // this.activeConversation.name = this.editedName.trim();
      // TODO: Call API to save changes
      const payload = {
        title: this.editedName.trim() ,
        avatar_url: this.activeConversation?.avatar ,
      };
      this.state.patchConversationName(this.activeConversation?.id || '', payload).subscribe({
        next: (res: any) => {
          if (res.status === SUCCESS) {
            if (this.activeConversation) {
              this.activeConversation.name = this.editedName.trim();
            }
            this.isEditing = false;
            this.toastr.success(`The conversation name have been updated.`, 'Name updated', {
              progressBar: true,
              closeButton: true,
            })
          }
        },  error: (err: any) => {
          // Handle error
          this.isEditing = false;
        }
      });
    }
  }

  cancelEdit() {
    this.isEditing = false;
  }

  async onImagePicked(event: any) {
    const file = event.target.files[0];
    if (file) {
      var filepath = `${this.id}/conversations/${this.activeConversation?.id || 'general'}/images/${new Date().getTime()}_${file.name}`;
      filepath = filepath.replace(/ /g, "_");
      const upload_status = await this.uploadApi.azureupload(file, storage_user, container_user, filepath)
      if (upload_status.upload_status == 200) {
        const payload = {
          title: this.activeConversation?.name || '',
          avatar_url: upload_status.uploadpath,
        };
        this.state.patchConversationName(this.activeConversation?.id || '', payload).subscribe({
          next: (res: any) => {
            if (res.status === SUCCESS) {
              if (this.activeConversation) {
                this.activeConversation.avatar = upload_status.uploadpath;
                this.toastr.success(`The conversation profile pic have been updated.`, 'Profile pic updated', {
                  progressBar: true,
                  closeButton: true,
                })
              }
            }
          },  error: (err: any) => {
            // Handle error
            this.isEditing = false;
          }
        });
      }
    }
  }

  AddToGroup(){
    // console.log("add")
    const participantToAdd = this.contacts.filter((c) => c.selected).map(c => c.id);
    const payload = {
      participants: participantToAdd,
    }
    this.state.addParticipantsToConversation(this.activeConversation?.id || '', payload).subscribe({
      next: (res: any) => {
        if (res.status === SUCCESS) {
          this.toastr.success(`Selected participants have been added to the conversation.`, 'Participants Added', {
            progressBar: true,
            closeButton: true,
          })
          this.loadConversationInfo(this.activeConversation?.id || '')
          this.resetSelections()
        }
      }
    })
  }


  deleteChat() {
    // if (confirm('Are you sure you want to delete this chat?')) {
    //   console.log('Deleting chat:', this.activeConversation);
    //   // TODO: call API
    // }
    this.chat_api.deleteConversation(this.activeConversation?.id || '').subscribe({
      next: (res: any) => {
        if (res.status === SUCCESS) {
          this.toastr.success(`The conversation has been deleted.`, 'Conversation Deleted', {
            progressBar: true,
            closeButton: true,
          })
        }else{
          this.toastr.warning(`Only creator of the chat can delete the chat.`,`Action blocked!`)
        }
        this.loadConversation()
      },
      error:()=>{
        this.toastr.warning(`Only creator of the chat can delete the chat.`,`Action blocked!`)
      }
    })
  }

  onEditMessage(message: any) {
    // Can't edit a message the server hasn't confirmed yet.
    if (message?.status === 'sending' || message?.status === 'failed') return;
    message.is_editing = true;
    this.saveEditMessage = message.content;
    // message.editContent = message.content; // prefill
  }

  cancelMessageEdit(message: any) {
    message.is_editing = false;
    message.content = this.saveEditMessage;
    // message.editContent = '';
  }

  saveEdit(message: any) {
    const hasMedia = message.media && message.media.length > 0;
    const hasText = message.content.trim().length > 0;
    // If no text AND no media → block save
    if (!hasText && !hasMedia) return;

    this.ws.send(message_options.edit_message, {
      message_id: message.id,
      content: message.content.trim(),
    });
    // message.content = message.editContent;
    message.is_editing = false;
    // console.log (message)
    // TODO: Call API to update backend
  }

  onDeleteMessage(message: any) {
    // A still-sending / failed message has no server id — route to the local remover.
    if (message?.status === 'sending' || message?.status === 'failed') {
      this.deleteFailedMessage(message);
      return;
    }
    this.ws.send(message_options.delete_message, {
      message_id: message.id,
    });
    // if (confirm('Delete this message?')) {
    message.deleted = true;
      // message.content = '[deleted]';
    //   // TODO: Call API to delete backend
    // }
  }

  formatDisplayDate(date: string): string {
    const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    const yesterday = this.datePipe.transform(new Date(Date.now() - 86400000), 'yyyy-MM-dd');

    if (date === today) return 'Today';
    if (date === yesterday) return 'Yesterday';
    return this.datePipe.transform(date, 'MMM d, y') || '';
  }

  groupMessages(messages: any[]): any[] {
    if (!messages || !messages.length) return [];

    const groupedByDate: any[] = [];
    let currentDateKey = '';
    let currentDateGroup: any[] = [];

    messages.forEach((msg, idx) => {
      const dateKey = new Date(msg.created_at).toDateString();

      if (dateKey !== currentDateKey) {
        if (currentDateGroup.length) {
          groupedByDate.push({ date: currentDateKey, groups: this.groupBySender(currentDateGroup) });
        }
        currentDateKey = dateKey;
        currentDateGroup = [];
      }

      currentDateGroup.push(msg);

      // Push the last group at end
      if (idx === messages.length - 1) {
        groupedByDate.push({ date: currentDateKey, groups: this.groupBySender(currentDateGroup) });
      }
    });
    // console.log( groupedByDate)
    return groupedByDate;
  }

  private groupBySender(messages: any[]): any[] {
    const grouped: any[] = [];
    let currentSender = '';
    let currentGroup: any[] = [];
    let lastTimestamp: Date | null = null;
    const threshold = 5 * 60 * 1000; // 5 minutes

    messages.forEach((msg, idx) => {
      const ts = new Date(msg.created_at);

      if (
        msg.sender_id !== currentSender ||
        (lastTimestamp && ts.getTime() - lastTimestamp.getTime() > threshold)
      ) {
        if (currentGroup.length) {
          grouped.push({ sender_id: currentSender, messages: currentGroup });
        }
        currentSender = msg.sender_id;
        currentGroup = [];
      }

      currentGroup.push(msg);
      lastTimestamp = ts;

      // Push last one
      if (idx === messages.length - 1) {
        grouped.push({ sender_id: currentSender, messages: currentGroup });
      }
    });

    return grouped;
  }

  formatDateSeparator(dateStr: string): string {
    const date = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    if (date.toDateString() === today.toDateString()) return 'Today';
    if (date.toDateString() === yesterday.toDateString()) return 'Yesterday';

    return date.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
  }

  onFileSelect(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.prepareFile(file);
    }
  }

  openAttachmentMenu() {
    this.isAttachmentMenuOpen = !this.isAttachmentMenuOpen;
  }

  // In your component.ts
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    setTimeout(() => {
      if (!this.eRef.nativeElement.contains(event.target)) {
        this.isAttachmentMenuOpen = false;
      }
    }, 0);
  }

  triggerFileInput(type: string) {
    let accept = '';
    switch (type) {
      case 'image':
        accept = 'image/*';
        break;
      case 'video':
        accept = 'video/*';
        break;
      case 'audio':
        accept = 'audio/*';
        break;
      case 'document':
        accept = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt'; // adjust as needed
        break;
    }

    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = accept;
    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.prepareFile(file);
      }
    };
    fileInput.click();

    this.isAttachmentMenuOpen = false; // close menu after selecting
  }

  onFileDrop(event: any) {
    const file = event.item?.data || event.dataTransfer?.files[0];
    console.log("Dropped:", file)
    if (file) {
      this.prepareFile(file);
    }
    this.isDragOver = false;
  }

  onDragOver(event: DragEvent) {
    // console.log("onDragOver:", event)
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    // console.log("onDragLeave:", event)
    this.isDragOver = false;
  }

  prepareFile(file: File) {

    const maxSize = 50 * 1024 * 1024; // 50MB in bytes

    // Block dangerous extensions
    const blockedExtensions = ['exe', 'bat', 'sh', 'cmd', 'msi', 'apk', 'com', 'jar', 'scr'];
    const fileExt = file.name.split('.').pop()?.toLowerCase();
    if (fileExt && blockedExtensions.includes(fileExt)) {
      this.toastr.error(`.${fileExt} files are not allowed.`, 'Blocked File');
      return;
    }

    if (file.size > maxSize) {
      this.toastr.error('The selected file is too large. Maximum allowed size is 50MB.', 'File Too Large');
      return; // Stop processing
    }

    this.attachedFile = file;
    this.uploadFile.name = file.name
    this.uploadFile.size = 0

    // Detect file type
    if (file.type.startsWith('image/')) {
      this.fileType = 'image';
      this.generatePreview(file);
    } else if (file.type.startsWith('video/')) {
      this.fileType = 'video';
      this.generatePreview(file);
    } else if (
      file.type === 'application/pdf' ||
      file.type.includes('word') ||
      file.type.includes('excel') ||
      file.type.includes('ppt')
    ) {
      this.fileType = 'document';
      this.filePreview = null;
    } else {
      this.fileType = 'other';
      this.filePreview = null;
    }
   var filepath = `${this.id}/conversations/${this.activeConversation?.id || 'general'}/images/${new Date().getTime()}_${file.name}`;
   filepath = filepath.replace(/ /g, "_");
  //  console.log(filepath)
   this.uploadApi.azureuploadChats(file, storage_user, container_user, filepath)
    .subscribe({
      next: (event: any) => {
        if (event.progress !== undefined) {
          this.uploadProgress = event.progress; // update progress bar

          this.uploadFile.url = event.status.uploadpath
          this.uploadFile.thumb_url = event.status.uploadpath
          this.uploadFile.mime_type = event.status.upload_file_type
          this.uploadFile.type = this.getFileCategory(file.type)
          // console.log(this.uploadProgress)
          // console.log(this.uploadFile)
          // console.log(event)
        }
        if (event.status) {
          // console.log("Upload complete:", event.status);
        }
      },
      error: err => console.error("Upload error", err),
      complete: () => console.log("Upload finished")
    });
  }

 getFileCategory(mimeType: string): "image" | "video" | "document" | "" {
    if (!mimeType) return "";

    if (mimeType.startsWith("image/")) {
      return "image";
    }
    if (mimeType.startsWith("video/")) {
      return "video";
    }

    // common document MIME types
    const documentTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "text/plain",
      "text/csv",
      "application/rtf",
    ];

    if (documentTypes.includes(mimeType)) {
      return "document";
    }

    return "";
  }

  generatePreview(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      this.filePreview = reader.result as string;
      // this.uploadFile.thumb_url = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  async removeFile() {
    const delete_file = this.uploadFile.url.split(`windows.net/${container_user}/`)[1];

      const response = await this.uploadApi.azuredelete(storage_user, container_user, delete_file)
      if (response.upload_status == 200) {
          this.toastr.success(`The media file was deleted.`, `Deleted`)
          this.attachedFile = null;
          this.filePreview = null;
          this.fileType = null;
          this.uploadFile = {
            url: '',
            type: '',
            mime_type: '',
            size: 0,
            name: '',
            thumb_url: ''
          };
      }
      this.uploadProgress = 0
  }
}
